import styled, { css }from "styled-components";
import { Link } from "react-router-dom";

export const LogoImg = styled.img` `;

export const LogoWrapper = styled(Link)`
  cursor: pointer;

  ${({ position }) => position === "left" && css`
    margin-left: 16px;
  `};
  
  ${({ position }) => position === "center" && css`
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  `};

  ${({ position }) => position === "matchdetail" && css`
    align-items: center;
    bottom: 0;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;

    ${LogoImg} {
      width:300px;
    }
    
  `};
  
`;
